import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ICONS_ENUM } from '@app/open-insurance/shared/constants/icons';

import { IDialogDetail } from './dialog-details.model';

@Component({
  selector: 'app-dialog-details',
  templateUrl: './dialog-details.component.html',
  styleUrls: ['./dialog-details.component.scss'],
  standalone: false
})
export class DialogDetailsComponent {
  ICONS = ICONS_ENUM;

  constructor(@Inject(MAT_DIALOG_DATA) public details: IDialogDetail) {}
}
